module Internal.ConcurUtil where

import Prelude

import Concur.Core (Widget)
import Concur.React (HTML)

loopInfinitely :: forall a b. Widget HTML a -> Widget HTML b
loopInfinitely w = do
   _ <- w
   loopInfinitely w

